
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UIBlockingService } from '../core/ui-blocking.service';
import { PaymentHistoryService } from './payment-history.service';
import { ToastNotificationService } from '../core/toast-notification.service';
import { DumbSuperPayment } from './DTOs/dumb-super-payment';
import { AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { DumbMemberListItem } from '../super-admin-member-management/DTOs/dumb-member-list-item';
import { formatDate, MbscDatepickerOptions, MbscDateType, MbscInput, MbscPopup, MbscPopupOptions, MbscSelect, MbscSelectChangeEvent, MbscSelectData, MbscSelectOptions, options, setOptions, } from '@mobiscroll/angular';
import { Observable } from 'rxjs';
import { SuperPaymentHistoryDTInfo } from './DTOs/super-payment-history-dtinfo';
import { GetPaymentHistoryRequest } from './DTOs/get-payment-history-request';
import saveAs from 'file-saver';

setOptions({
  theme: 'ios',
    themeVariant: 'dark',
  display: 'anchored',
});
const now = new Date();
const day = now.getDay();
const monday = now.getDate() - day + (day === 0 ? -6 : 1);
const startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate()).toDateString();
const endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate()).toDateString();

@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  providers: [UIBlockingService, NgbDropdown],
  encapsulation: ViewEncapsulation.None
})

export class PaymentHistoryComponent {
  @ViewChild('popup', { static: false })
  popup!: MbscPopup;

  @ViewChild('input', { static: false })
    input!: MbscInput;
  @ViewChild('select', { static: false })
    select!: MbscSelect;
  @ViewChild('memberSelect', { static: false })
    memberSelect!: HTMLElement;
  constructor(private paymentHistoryService: PaymentHistoryService
    , private blockUI: UIBlockingService
    , private notificationService: ToastNotificationService
    , private modalService: NgbModal) {

  }

    inputElm!: HTMLElement;
  dateInput = '';
  dateSelector = 'today';
  disableDateInput = false;
  selectedDate: MbscDateType[] = [startDate, endDate];
  payments: DumbSuperPayment[] = [];
  totalPayments = 0;
  filteredPayments = 0;
  pageNum = 1;
  itemsPerPage = 10;
  searchText = "";
  statusSearch = { display: "Unpaid", value: 4 };
  sortType = 1;
  keywordSearches: string[] = [];
  memberInput: any;
  memberInputString: string = "";
  filtersChanged = true;
  initialLoad = true;
  get currentPageNum() { return this.pageNum };
  set currentPageNum(page: number) {
    this.pageNum = page;
    if (!this.initialLoad) {
      this.getPayments();
    }
  }
  get itemStart() {
    if (this.payments.length == 0) {
      return 0;
    }
    else
      return ((this.currentPageNum - 1) * this.itemsPerPage) + 1;
  }
  get itemEnd() {
    return ((this.currentPageNum - 1) * this.itemsPerPage) + this.payments.length;
  }

  membersForFilter: any;

  remoteOptions: MbscSelectOptions = {
    onFilter: (ev: any) => {
      this.getMembersForFilter(ev.filterText);
      return false;
    },
  };


  //=======Functions=============================

  ngOnInit(): void {
      this.changeInputValue(startDate, endDate);
      this.getMembersForFilter('');
      this.getPayments();
      this.initialLoad = false;
    }

  setMemberText(evt: any) {
      this.memberInputString = evt.valueText;
  }

  getPaymentsObservable(): Observable<SuperPaymentHistoryDTInfo> {
    var req = this.createSearchRequest();
    return this.paymentHistoryService
      .searchPayments(req);
  }

  getPayments() {
    this.blockUI.start();

    this.getPaymentsObservable()
      .subscribe(
        {
          next: (data) => {
            this.payments = data.data;
            this.totalPayments = data.recordsTotal;
            this.filteredPayments = data.recordsFiltered;
          },
          error: (err) => {
            this.notificationService.error(err.error.message);
            this.blockUI.stop();
            console.log(err)
          },
          complete: () => {
            this.blockUI.stop();
          }
        });
  }

  createSearchRequest(): GetPaymentHistoryRequest {
    var req = new GetPaymentHistoryRequest();

    if (this.filtersChanged)
      this.pageNum = 1;

    req.PageNumber = this.pageNum - 1; //to get the 0-indexed number
    req.ItemsPerPage = this.itemsPerPage;

    req.KeywordSearches = this.keywordSearches;
    req.Sorting = this.sortType;
      // req.StatusFilter = this.statusSearch.value;

    req.StartDate = new Date(this.selectedDate[0].toString()).toDateString();
    req.EndDate = new Date(this.selectedDate[1].toString()).toDateString();
    req.memberIds = this.memberInput;

    this.filtersChanged = false;

    return req;
  }

  downloadCsv() {
    var req = this.createSearchRequest();
    this.blockUI.start();
    return this.paymentHistoryService
      .searchPaymentsCsv(req).subscribe(
        {
          next: (buffer) => {
            const data: Blob = new Blob([buffer], {
              type: "text/csv;charset=utf-8"
            });
            saveAs(data, "payment_history_info.csv");
          },
          error: (err) => {
            this.notificationService.error(err.error.message);
            this.blockUI.stop();
            console.log(err)
          },
          complete: () => {
            this.blockUI.stop();
          }
        });;
  }

  getMembersForFilter(filterText) {
    this.blockUI.start();
    return this.paymentHistoryService
      .getMembersForFilter(filterText).subscribe(
        {
          next: (data) => {
            const members = [];
            for (const item of data) {
              members.push({ text: item.companyName, value: item.memberId });
            }
            this.membersForFilter = members;
          },
          error: (err) => {
            this.notificationService.error(err.error.message);
            this.blockUI.stop();
            console.log(err)
          },
          complete: () => {
            this.blockUI.stop();
          }
        });
  }
  changeStatusSearch(toChange: number) {
    if (this.statusSearch.value == toChange)
      return;

    this.filtersChanged = true;
    switch (toChange) {
      case -1:
        this.statusSearch = { display: "All", value: -1 };
        break;
      case 0:
        this.statusSearch = { display: "Invoiced", value: 0 };
        break;
      case 1:
        this.statusSearch = { display: "Partially Paid", value: 1 };
        break;
      case 2:
        this.statusSearch = { display: "Paid In Full", value: 2 };
        break;
      case 3:
        this.statusSearch = { display: "Past Due", value: 3 };
        break;
      case 4:
        this.statusSearch = { display: "Unpaid", value: 4 };
        break;
      case -9999:
        this.statusSearch = { display: "Cancelled", value: -9999 };
        break;
      default:
        this.statusSearch = { display: "All", value: -1 };
        break;
    }
    this.getPayments();
  }
  clearSearch() {
    this.membersForFilter = [];
    this.searchText = "";
    this.statusSearch = { display: "Active", value: 1 };
    this.sortType = 1;
    this.keywordSearches = [];
    this.filtersChanged = true;
    this.getPayments();
  }
    hitSearchBtn() {
    this.searchText.trim().split(' ').forEach((term) => { if (term != '') { this.keywordSearches.push(term) } });
    this.searchText = '';
    this.filtersChanged = true;
    this.getPayments();
  }
  changeSortType(column: number) {
    switch (column) {
      case 1:
        this.sortType = (this.sortType == 1) ? 2 : 1;
        break;
      case 2:
        this.sortType = (this.sortType == 3) ? 4 : 3;
        break;
      case 3:
        this.sortType = (this.sortType == 5) ? 6 : 5;
        break;
      default:
        break;
    }
    this.filtersChanged = true;
    this.getPayments();
  }
  enterSearchTerm(event: any) {
    if (event.keyCode != 13)//13 is enter, 32 is space
      return;

    this.searchText.trim().split(' ').forEach((term) => { if (term != '') { this.keywordSearches.push(term) } });
    this.searchText = '';
    this.filtersChanged = true;
    this.getPayments();
    return;
  }
  removeSearchTerm(term: string) {
    var index = this.keywordSearches.indexOf(term);
    if (index != -1) {
      this.keywordSearches.splice(index, 1);
      this.filtersChanged = true;
    }
    this.getPayments();
  }
  respPopup: { [key: string]: MbscPopupOptions & { breakpoint?: number } } = {
    xsmall: {
      display: 'bottom',
      touchUi: true,
      buttons: [
        {
          text: 'Apply',
          handler: () => {
            this.changeInputValue(this.selectedDate[0] as string, (this.selectedDate[1] || this.selectedDate[0]) as string);
            this.popup.close();
          },
        },
        'cancel',
      ],
    },
    custom: {
      breakpoint: 559,
      buttons: [],
      display: 'anchored',
      anchorAlign: 'start',
      touchUi: false,
      scrollLock: false,
      showArrow: false,
      maxWidth: 920,
    },
  };

  respSelect = {
    xsmall: {
      touchUi: true,
    },
    small: {
      touchUi: false,
    },
  };
  myData: MbscSelectData[] = [
    {
      value: 'custom',
      text: 'Custom',
    },
    {
      value: 'today',
      text: 'Today',
    },
    {
      value: 'yesterday',
      text: 'Yesterday',
    },
    {
      value: 'last-week',
      text: 'Last week',
    },
    {
      value: 'last-month',
      text: 'Last month',
    },
    {
      value: 'last-7-days',
      text: 'Last 7 days',
    },
    {
      value: 'last-30-days',
      text: 'Last 30 days',
    },
  ];

  selectOptions: MbscSelectOptions = {
    responsive: {
      xsmall: {
        touchUi: true,
      },
      small: {
        touchUi: false,
      },
    },
    onChange: (args) => {
      const s = args.value;

      if (s === 'custom') {
        this.disableDateInput = false;
      } else {
        this.disableDateInput = true;

        switch (s) {
          case 'today':
            this.selectedDate = [
              new Date(now.getFullYear(), now.getMonth(), now.getDate()),
              new Date(now.getFullYear(), now.getMonth(), now.getDate())];
            break;
          case 'yesterday':
            this.selectedDate = [
              new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1),
              new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1)];
            break;
          case 'last-week':
            this.selectedDate = [
              new Date(now.getFullYear(), now.getMonth(), monday - 7),
              new Date(now.getFullYear(), now.getMonth(), monday - 1)
            ];
            break;
          case 'last-month':
            this.selectedDate = [
              new Date(now.getFullYear(), now.getMonth() - 1, 1),
              new Date(now.getFullYear(), now.getMonth(), 1)
            ];
            break;
          case 'last-7-days':
            this.selectedDate = [
              new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7),
              new Date(now.getFullYear(), now.getMonth(), now.getDate())];
            break;
          case 'last-30-days':
            this.selectedDate = [
              new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30),
              new Date(now.getFullYear(), now.getMonth(), now.getDate())];
            break;
          default:
            break;
        }
      }
        this.dateSelector = s;
    },
  };

  calendarOptions: MbscDatepickerOptions = {
    controls: ['calendar'],
    select: 'range',
    display: 'inline',
    showRangeLabels: false,
    pages: 'auto',
    returnFormat: 'jsdate',
    showOnClick: false,
    showOnFocus: false,
    onChange: () => {
      this.disableDateInput = false;
    },
  };
  inputClick(): void {
    this.popup.open();
    }
    activateSelect(): void {
        this.select.open();
    }

  changeInputValue(start: string, end: string): void {
    const locale = options.locale || {};
    const dateFormat = locale.dateFormat || 'MM/DD/YYYY';

    this.dateInput = formatDate(dateFormat, new Date(start)) + ' - ' + formatDate(dateFormat, new Date(end));
  }

  applyClick(): void {
      const date = this.selectedDate;

    this.changeInputValue(date[0] as string, (date[1] || date[0]) as string);
    this.popup.close();
    this.getPayments();

  }

  cancelClick(): void {
    this.popup.close();
  }


  ngAfterViewInit(): void {
    setTimeout(() => {
        this.inputElm = this.input.nativeElement;
    });
  }


}
